import { useState, useEffect } from 'react';
import { api } from '../services/api';

/**
 * Badge de versão — exibe ENV + semver + SHA curto.
 * Visível apenas para admin e manager. Clicável para detalhes.
 */
export default function VersionBadge() {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.getVersion()
      .then(setInfo)
      .catch(() => null);
  }, []);

  if (!info) return null;

  const isProd    = info.env === 'production';
  const isStaging = info.env === 'staging';
  const envLabel  = isProd ? 'PROD' : isStaging ? 'STAGING' : info.env?.toUpperCase() || 'DEV';
  const envColor  = isStaging ? '#FF8900' : '#00DBFF';
  const sha       = info.gitSha?.slice(0, 7) || '?';

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="hidden md:flex items-center gap-1.5 px-2 py-0.5 rounded text-[10px] font-mono transition-opacity hover:opacity-80"
        style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)' }}
        title="Versão do sistema"
      >
        <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: envColor }} />
        <span style={{ color: envColor }}>{envLabel}</span>
        <span>v{info.version}</span>
        <span style={{ color: 'rgba(255,255,255,0.30)' }}>· {sha}</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          onClick={() => setOpen(false)}
        >
          <div
            className="rounded-xl p-5 w-80 space-y-2 text-sm"
            style={{ backgroundColor: '#01334d', border: '1px solid rgba(255,255,255,0.12)' }}
            onClick={e => e.stopPropagation()}
          >
            <p className="font-bold text-white text-base mb-3">Versão do sistema</p>
            {[
              ['Versão',     `v${info.version}`],
              ['Ambiente',   envLabel],
              ['Git SHA',    info.gitSha || '—'],
              ['Migration',  info.migration ?? '—'],
              ['Deploy em',  info.deployedAt
                ? new Date(info.deployedAt).toLocaleString('pt-BR')
                : '—'],
              ['Uptime',     info.uptime
                ? `${Math.floor(info.uptime / 3600)}h ${Math.floor((info.uptime % 3600) / 60)}m`
                : '—'],
            ].map(([k, v]) => (
              <div key={k} className="flex justify-between">
                <span style={{ color: 'rgba(255,255,255,0.5)' }}>{k}</span>
                <span className="font-mono text-white">{v}</span>
              </div>
            ))}
            <button
              onClick={() => setOpen(false)}
              className="w-full mt-3 py-1.5 rounded text-xs font-semibold"
              style={{ backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.6)' }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
